import { buildUtsavaSpans } from "./panchanga-grid";

/**
 * If today falls inside a multi-day utsava span in the civil month.
 */
export function findUtsavaToday(monthDays, todayDateStr, monthName) {
  if (!monthDays?.length || !todayDateStr) return null;
  const idx = monthDays.findIndex((d) => d.date === todayDateStr);
  if (idx < 0) return null;
  const spans = buildUtsavaSpans(monthDays, monthName);
  for (const span of spans) {
    if (idx >= span.startIndex && idx <= span.endIndex) {
      return {
        name: span.name,
        dateRange: span.dateRange,
        dayNumber: idx - span.startIndex + 1,
        totalDays: span.endIndex - span.startIndex + 1,
        sourceDay: monthDays[idx],
        span,
      };
    }
  }
  return null;
}

export function sadhanaOneLiner(panchanga) {
  if (!panchanga) return null;
  const g = panchanga.sadhana_guide;
  if (g?.mid_morning) return g.mid_morning;
  if (g?.morning) return g.morning;
  if (g?.sandhya) return g.sandhya;
  const p = panchanga.recommended_practices?.[0];
  return p || null;
}
